module.exports = __webpack_public_path__ + "img/logo-app-white.c66eb497.png";